import { useState, useEffect } from 'react';
import Navbar from './Navbar';
export default function useNavbar(config,defaultSelected){

  const resolvedDefault = defaultSelected || config?.options?.[0]?._id;

  useEffect(() => {
    setSelected(defaultSelected);
  },[defaultSelected])

  let { options, type="navbar", onChange, forceSelected } = config;

  const [selected,_setSelected] = useState(resolvedDefault);

  const setSelected = (val) => {
    onChange && onChange(val);
    _setSelected(val);
  }

  let resolvedSelected = selected;
  if( "forceSelected" in config ){
    resolvedSelected = config.forceSelected;
  }

  if( type === "select" ){
    return (
      [resolvedSelected,
      <select onChange={e => {
        let val = e.target.value;
        setSelected(val);
      }} value={resolvedSelected}
        {...config}
      >
        {options.map(opt => {
          return (
            <option value={opt._id}>
              {opt.label}
            </option>
          )
        })}
      </select>]
    )
  }

  return [
    resolvedSelected,
    <Navbar {...{...config,selected:resolvedSelected,onSelect:setSelected,spread:false}}/>,
    setSelected
  ];



}
